import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { midas } from '@resurs/midas'
import {
  getUserRoles,
  addUser,
  saveUser,
  resetUser,
} from '../../../store/actions/users-actions'
import AddSingleUserUI from './UI/AddSingleUserUI'
import { sendAddSingleUserEvent } from '../../../util/ga-helpers'

const AddSingleUser = props => {
  const [user, setUser] = useState()

  useEffect(() => {
    props.getUserRoles()
    props.addUser()
    return () => props.resetUser()
  }, [])

  useEffect(() => {
    setUser(props.user)
  }, [props.user])

  return (
    <div>
      {user ? (
        <AddSingleUserUI
          user={user}
          loggedInUser={props.loggedInUser}
          validRoles={props.validRoles}
          onSave={usr => {
            sendAddSingleUserEvent('Complete')
            props.saveUser(usr)
          }}
        />
      ) : (
        <div
          style={{ position: 'absolute', top: '50%', left: '50%' }}
          className={midas.loading}
        />
      )}
    </div>
  )
}

AddSingleUser.propTypes = {
  user: PropTypes.object, //eslint-disable-line
  loggedInUser: PropTypes.object.isRequired,
  validRoles: PropTypes.array.isRequired,
  addUser: PropTypes.func.isRequired,
  getUserRoles: PropTypes.func.isRequired,
  saveUser: PropTypes.func.isRequired,
  resetUser: PropTypes.func.isRequired,
}

AddSingleUser.defaultProps = {
  user: {},
}

const mapStateToProps = state => ({
  user: state.users.currentUser,
  loggedInUser: state.auth,
  validRoles: state.users.validRoles,
  representatives: state.storeInfo.representatives,
  notify: state.notify,
})

const mapDispatchToProps = dispatch => ({
  saveUser: user => dispatch(saveUser(user)),
  addUser: () => {
    dispatch(addUser())
  },
  getUserRoles: () => {
    dispatch(getUserRoles())
  },
  resetUser: () => {
    dispatch(resetUser())
  },
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddSingleUser),
)
